import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useApi } from '@/hooks/useApi';
import type { OutreachAccessRequest } from '@/api/types';

const KEYS = {
  mine: ['access-request', 'mine'] as const,
};

export function useMyAccessRequest() {
  const api = useApi();
  return useQuery({
    queryKey: KEYS.mine,
    queryFn: () => api.get<OutreachAccessRequest | null>('/portal/access-requests/me'),
    // The viewer-side polling doesn't need to be aggressive — admin reviews
    // are async (minutes-to-hours). Refresh on window focus is enough.
    refetchInterval: false,
  });
}

export interface CreateAccessRequestBody {
  requestedTeam?: string;
  note: string;
}

export function useCreateAccessRequest() {
  const api = useApi();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: CreateAccessRequestBody) =>
      api.post<OutreachAccessRequest>('/portal/access-requests', body),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEYS.mine }),
  });
}
